import commonApi from "../../api/commonConfig";
import uaaApi from "../../api/uaaConfig";

export const updateUserInfo = (data) => {
  return uaaApi({ method: "put", url: "/api/v1/user", data });
};

export const updateUserPassword = (data) => {
  return uaaApi({
    method: "put",
    url: "/api/v1/user/reset-password-by-admin",
    data,
  });
};

export const updateCurentUserPassword = (data) => {
  return uaaApi({
    method: "put",
    url: "/api/v1/user/change-password",
    data,
  });
};

export const getListLanguage = (params) => {
  return commonApi({ url: "/api/v1/language", method: "get", params });
};

export const getListCountry = (params) => {
  return commonApi({ url: "/api/v1/country", method: "get", params });
};

export const uploadUserAvatar = (data, params = {}) => {
  return uaaApi({
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    url: "/api/v1/user/upload-user-image",
    data,
    params,
  });
};
